<template>
  <span class="v-tooltip">
    <span class="v-tooltip__text">
      <h3 class="v-tooltip__header mb-2">
        {{ capitalize(roommateTitle) }} Code
      </h3>
      <p class="mb-2">
        <small>
          Share this code with other students and they'll be able to join your
          {{ roommateTitle }} group. Click to copy to your clipboard.
        </small>
      </p>
      <p class="badge bg-primary fs-2 mb-2">
        {{ code }}
      </p>
      <p class="v-tooltip__warning">
        <small>
          Keep this code safe and don't share it with anyone except perspective
          members of your {{ roommateTitle }} group
        </small>
      </p>
    </span>
  </span>
</template>

<script setup lang="ts">
import capitalize from "lodash-es/capitalize";
import { inject } from "vue";

interface Props {
  code: string;
}

defineProps<Props>();

const roommateTitle = inject<string>("roommateTitle");
</script>

<style lang="scss" scoped>
@use "~/stylesheets/globals";
@use "sass:map";

$color: map.get(globals.$theme-colors, "primary");

.v-tooltip {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__text {
    width: 300px;
    color: $color;
    text-align: center;
  }

  &__warning small {
    color: red;
  }

  &__header {
    margin-top: 0px;
  }

  p {
    margin: 0px;
  }
  small {
    font-size: 85%;
  }
}
</style>
